import "./styles.scss";

const CardCMCS = ({ statusCollab }) => {
  const isStatus = statusCollab.data?.status === "ok";

  return (
    <div className="countersInfo">
      <div className="statusCounter">
        <span className="titleInfo">Status Collab</span>
        <span className={`status ${isStatus ? "active" : "inactive"}`}>{isStatus ? "Active" : "Inactive"}</span>
      </div>
    </div>
  );
};

export default CardCMCS;
